import { Button } from '@/components/ui/button'
import { useTimeEntryBillCurrencyReviewQuery } from '@/hooks/queries/useTimeEntriesQuery'
import { usePermissions } from '@/hooks/usePermissions'

import { ModuleTypeEnum, PermissionActionEnum } from '@scrambl/shared'

export function BillCurrencyReviewAction({
  entryId,
  onClick,
}: {
  entryId: string
  onClick: (version: number) => void
}) {
  const { checkPermission } = usePermissions()
  const canReview =
    checkPermission(ModuleTypeEnum.TIME_ENTRY, PermissionActionEnum.MANAGE) &&
    checkPermission(ModuleTypeEnum.FINANCIALS, PermissionActionEnum.MANAGE)
  const { data } = useTimeEntryBillCurrencyReviewQuery(entryId, {
    enabled: canReview,
  })
  if (!canReview || !data?.required) return null
  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      onClick={() => onClick(data.version)}
    >
      Review bill currency
    </Button>
  )
}
